import { Model } from '@/models/Model';
export class Log extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Log';
        this.$endpoint = '/logs';
        this.$fillable = [];
    }
}
